/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 积分商城商品详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  commodityId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.CommodityDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/commodity/${commodityId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
